import '@common';
import riot from 'riot';
import { mixStore } from '@common/lib/store';
import route from 'riot-route';
import * as action from './action/index';
import './router';
import store from './store/index';
import './style.css';

const importAll = (r) => { r.keys().forEach(r) };
importAll(require.context('./', true, /\.tag$/));

window.onload = () => {
  riot.mixin('password', {
    checkPassword(e) {
      if (e.target.checked) {
        this.refs.password.setAttribute('type', 'text');
      } else {
        this.refs.password.setAttribute('type', 'password');
      }
    }
  });
  mixStore(store, action);
  riot.mount('app');
  route.start(true);
};